











import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { IMessage } from '@/store/alert/types';
import { RootState } from '@/store/types';
import Alert from '@/components/Alert.vue';

@Component({
  components: {
    Alert,
  },
})
export default class ActivationEmail extends Vue {
  @Action('activationEmail', { namespace: 'user' }) private activationEmail: (
    code: String,
  ) => void;
  @Prop(String) private activationCode: string;

  mounted() {
    this.activationEmail(this.activationCode);
  }

  onLogin() {
    this.$router.push('/');
  }
}
